var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoInternet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 94,
    viewBox: "0 0 100 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.664,
    y1: -2.309,
    x2: 0.426,
    y2: 1.765,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#90358a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711f7c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25",
    "data-name": "Layer 25",
    transform: "translate(-6.041 -8.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5185",
    "data-name": "Path 5185",
    d: "M55.768,43.71a1.665,1.665,0,0,0,0,2.355,16.658,16.658,0,1,1-23.558,0,1.666,1.666,0,1,0-2.355-2.355,19.989,19.989,0,1,0,28.269,0,1.665,1.665,0,0,0-2.355,0Z",
    transform: "translate(12.052 24.194)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5186",
    "data-name": "Path 5186",
    d: "M49.447,24.56A44.022,44.022,0,0,0,18.142,37.486,7.508,7.508,0,0,0,28.783,48.08a29.318,29.318,0,0,1,41.345,0A7.5,7.5,0,1,0,80.753,37.486,44.022,44.022,0,0,0,49.447,24.56Z",
    transform: "translate(6.593 11.318)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5187",
    "data-name": "Path 5187",
    d: "M103.839,27.754a67.772,67.772,0,0,0-95.6,0A7.51,7.51,0,0,0,18.874,38.365a52.692,52.692,0,0,1,74.334,0,7.51,7.51,0,1,0,10.631-10.611Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_150",
    "data-name": "Ellipse 150",
    cx: 4.997,
    cy: 4.997,
    r: 4.997,
    transform: "translate(51.043 83.704)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5188",
    "data-name": "Path 5188",
    d: "M38,60.32a5.012,5.012,0,0,0,5-5V42A5,5,0,0,0,33,42V55.323a5.012,5.012,0,0,0,5,5Z",
    transform: "translate(18.043 19.816)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInternet);
export default __webpack_public_path__ + "static/media/no_internet.2d44045aa44e22b56fdc98a36dea13ec.svg";
export { ForwardRef as ReactComponent };